import { Button, IconRepeat, Wrapper } from '@screentone/core';

import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { ExternalCollectionItem } from 'data/generated/graphql';

interface DetachFromCollectionProps {
  hierarchyId: string;
  collection: ExternalCollectionItem;
  disabled?: boolean;
}

export const DetachFromCollection = ({ hierarchyId, collection, disabled = false }: DetachFromCollectionProps) => {
  const { insertEntity, removeEntity } = useDataModelContext();

  const handleDetachFromCollection = () => {
    const articleItems = collection.contentItems;

    removeEntity(hierarchyId);
    insertEntity(hierarchyId, articleItems);
  };

  return (
    <Wrapper>
      <ReadOnlyTooltip disabled={disabled}>
        <Button
          tertiary
          icon={IconRepeat}
          onClick={handleDetachFromCollection}
          disabled={disabled || collection.contentItems.length === 0}
          data-testid="collection-detach-from-collection"
        >
          Detach from Collection
        </Button>
      </ReadOnlyTooltip>
    </Wrapper>
  );
};
